import React from 'react';
import './WishListIcon.scss';

const WishListIcon = props => {
  const {
    isShortlisted,
    dataLocale,
    onClickHandler,
    customStyles = {},
    wishlistWrapperStyle = {},
  } = props;
  const { REMOVE_FROM_SHORTLIST, ADD_TO_SHORTLIST } = dataLocale;

  return (
    <>
      <div
        className="wishlist pos-abs right-10 top-15"
        style={wishlistWrapperStyle}
        onClick={onClickHandler}
      >
        <span
          className={`wishlist-icon cursor-pointer text-center fa fs20 ${
            !isShortlisted ? 'fa-heart-o text-color-black' : 'fa-heart text-color-red'
          }`}
          style={customStyles}
          title={isShortlisted ? REMOVE_FROM_SHORTLIST : ADD_TO_SHORTLIST}
        ></span>
      </div>
    </>
  );
};

export default WishListIcon;
